import { render } from "./IncomeCategory.vue?vue&type=template&id=181d6d16&scoped=true&ts=true"
import script from "./IncomeCategory.vue?vue&type=script&lang=ts"
export * from "./IncomeCategory.vue?vue&type=script&lang=ts"

import "./IncomeCategory.vue?vue&type=style&index=0&id=181d6d16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181d6d16"]])

export default __exports__